import { render } from "./MarketsDashboard.vue?vue&type=template&id=0fca7f38&scoped=true"
import script from "./MarketsDashboard.vue?vue&type=script&lang=js"
export * from "./MarketsDashboard.vue?vue&type=script&lang=js"

import "./MarketsDashboard.vue?vue&type=style&index=0&id=0fca7f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fca7f38"]])

export default __exports__